import React from "react";
import { Alert } from "react-bootstrap";

export default function CustomAlert(props) {
  const { showAlert, handleCloseAlert, header, content, variant } = props;

  if (showAlert) {
    return (
      <Alert
        variant={variant || "danger"}
        dismissible
        className="w-100"
        onClose={() => handleCloseAlert()}
      >
        <Alert.Heading>{header}</Alert.Heading>
        <hr />
        <p>{content}</p>
      </Alert>
    );
  }
  return null;
}
